
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  homeLinkImprint: {
    id: "HomeLink.imprint",
    defaultMessage: "Imprint",
  },
  homeLinkLegals: {
    id: "HomeLink.legals",
    defaultMessage: "Legals",
  },
  homeLinkPrivacy: {
    id: "HomeLink.privacy",
    defaultMessage: "Privacy Policy",
  },
});

export default MESSAGES;